import React from 'react';
import classNames from 'classnames';
import i18n from '@i18next/i18n';
import Tooltip from '@tencent/dui/lib/components/Tooltip';
import Preview from '@tencent/dui/lib/components/Preview';
import styles from '@src/slide/application/service/smart-replace-image/replace-dialog/replace-image-dialog.less';
import { ImageMoreInfo } from '../../components/image-more-info/image-more-info';

interface IAiReplaceImageContentRightProps {
    displayImages: IDisplayImageInfo[]; // 右侧展示的所有图片
    selectedIndex?: number; // 选中的图片序号
    selectImage: (index: number) => void; // 选中图片后的回调
    updateDisplayImages: () => void; // 更新展示的图片
}

interface IDisplayImageInfo {
    src: string,
    sourceUrl: string,
}

export const AiReplaceImageContentRight = ({
    displayImages,
    selectedIndex,
    selectImage,
    updateDisplayImages,
}: IAiReplaceImageContentRightProps) => {
    const showPreview = (index: number) => {
        Preview.show({
            disableDownload: true,
            initialIndex: index,
            images: displayImages.map(i => ({ url: i.src })),
        });
    };

    return (
        <div className={styles['content-right']}>
            <div className={styles['content-subtitle']}>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    {`${i18n.t('联网搜索的新图片')}`}
                    <Tooltip title={i18n.t('如需商用请自行获取授权')} placement={'top'}>
                        <div className={styles['info-icon']} />
                    </Tooltip>
                </div>
                <div className={styles.refresh} onClick={() => updateDisplayImages()}>
                    <div className={styles['refresh-icon']} />
                    {`${i18n.t('换一换')}`}
                </div>
            </div>
            <div className={styles['list-images']}>
                {displayImages.map((image, index) => (
                    <AiReplaceImageContainer
                        selected={index === selectedIndex}
                        key={`${image}${index}`}
                        src={image.src}
                        sourceUrl={image.sourceUrl}
                        selectImage={() => selectImage(index)}
                        showPreview={() => showPreview(index)}
                    />
                ))}
            </div>
        </div>
    );
};

const AiReplaceImageContainer = ({
    selected,
    key,
    src,
    selectImage,
    showPreview,
    sourceUrl,
}: {
    selected: boolean;
    key: string;
    src: string;
    selectImage: () => void;
    showPreview: () => void;
    sourceUrl?: string;
}) => (
    <div
        className={classNames({
            [styles['list-images-item-container']]: true,
            [styles['list-images-container-active']]: selected,
            [styles['list-images-container-idle']]: !selected,
        })}
        key={key}
        onClick={() => selectImage()}
    >
        <img className={styles['list-images-item']} src={src} />
        <div className={styles['current-image-loading']} style={{ backgroundColor: '#ffffff' }} hidden={!!src} />
        <ImageMoreInfo
            className={styles['current-image-pointer']}
            onPreViewClick={() => showPreview()}
            sourceUrl={sourceUrl}
        />
    </div>
);
